import { CheckCircle2, Truck, MapPin, PackageCheck, Radio } from "lucide-react";

export const STEPS = [
  { key: "validated", label: "Commande validée", icon: CheckCircle2 },
  { key: "assigned", label: "Livreur assigné", icon: Truck },
  { key: "route", label: "Livreur en route", icon: MapPin },
  { key: "arrived", label: "Livreur arrivé", icon: Radio },
  { key: "delivered", label: "Commande livrée", icon: PackageCheck },
];

export function currentStepIndex(o) {
  if (o.status === "delivered") return 4;
  if (o.arrived) return 3;
  if (o.status === "in_transit" || o.eta_minutes) return 2;
  if (o.driver_assigned) return 1;
  return 0;
}

export function statusBanner(order) {
  if (order.status === "delivered") return { text: "Commande livrée. Merci de votre confiance !", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/40" };
  if (order.arrived) return { text: "📍 Votre livreur est arrivé à l'adresse !", cls: "bg-amber-500/15 text-amber-200 border-amber-500/50" };
  if (order.exact_arrival_time) return { text: `⏰ Votre livreur arrive à ${order.exact_arrival_time} précises — soyez devant l'adresse à l'heure indiquée pour récupérer votre commande.`, cls: "bg-amber-500/20 text-amber-100 border-amber-500/60" };
  if (order.status === "in_transit" || order.eta_minutes) return { text: `🛵 Votre livreur est en route${order.eta_minutes ? ` — arrivée estimée dans ${order.eta_minutes >= 60 ? "1 h" : order.eta_minutes + " min"}` : ""}`, cls: "bg-amber-500/15 text-amber-200 border-amber-500/50" };
  if (order.driver_assigned) return { text: "Un livreur a pris en charge votre commande.", cls: "bg-blue-500/15 text-blue-200 border-blue-500/40" };
  return { text: "Commande validée — en attente d'un livreur.", cls: "bg-slate-500/15 text-slate-200 border-slate-500/40" };
}
